import React from 'react';

const PolitiqueDeConfidentialitePage = () => {
  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto', fontFamily: 'Arial, sans-serif', lineHeight: '1.6' }}>
      <h1 style={{ color: '#2c3e50' }}>Politique de Confidentialité</h1>

      <section>
        <h2 style={{ color: '#2c3e50' }}>1. Introduction</h2>
        <p>Chez [Nom de votre entreprise], nous nous engageons à protéger la confidentialité et la sécurité de nos utilisateurs. Cette politique de confidentialité explique comment nous recueillons, utilisons, et protégeons vos informations lorsque vous utilisez notre site web.</p>
      </section>

      <section>
        <h2 style={{ color: '#2c3e50' }}>2. Collecte des informations</h2>
        <p>Nous recueillons différents types d'informations pour diverses raisons, notamment pour améliorer notre site et personnaliser votre expérience. Nous utilisons des cookies pour suivre l'activité sur notre site et retenir certaines informations. Les cookies sont de petits fichiers de données qui sont transférés sur votre appareil.</p>
      </section>

      <section>
        <h2 style={{ color: '#2c3e50' }}>3. Utilisation des informations</h2>
        <p>Les informations que nous recueillons peuvent être utilisées pour :</p>
        <ul style={{ marginLeft: '20px' }}>
          <li>Personnaliser votre expérience sur notre site.</li>
          <li>Améliorer notre site web en nous basant sur les informations et retours que nous recevons de vous.</li>
          <li>Administrer des promotions, sondages, ou autres caractéristiques du site.</li>
          <li>Envoyer des emails périodiques relatifs à notre service ou autre information que nous jugeons pertinente pour vous.</li>
        </ul>
      </section>

      <section>
        <h2 style={{ color: '#2c3e50' }}>4. Consentement des utilisateurs</h2>
        <p>Lorsque vous visitez notre site pour la première fois, nous vous demandons de consentir à l'utilisation de cookies. Vous pouvez accepter ou refuser les cookies. Votre choix est enregistré dans un cookie afin de ne pas vous demander à nouveau lors de vos prochaines visites. Vous pouvez modifier votre choix à tout moment en visitant notre page de confidentialité.</p>
      </section>

      <section>
        <h2 style={{ color: '#2c3e50' }}>5. Sécurité des données</h2>
        <p>Nous prenons la sécurité de vos données très au sérieux. Nous mettons en œuvre des mesures de sécurité appropriées pour protéger vos données contre l'accès non autorisé, la modification, la divulgation ou la destruction.</p>
      </section>

      <section>
        <h2 style={{ color: '#2c3e50' }}>6. Droits des utilisateurs</h2>
        <p>Vous avez le droit d'accéder à vos informations personnelles, de demander des corrections, ou de demander leur suppression. Pour exercer ces droits ou pour toute question concernant vos données personnelles, veuillez nous contacter à [adresse email de contact].</p>
      </section>

      <section>
        <h2 style={{ color: '#2c3e50' }}>7. Contact</h2>
        <p>Pour toute question ou préoccupation concernant notre politique de confidentialité, vous pouvez nous contacter à [adresse email de contact].</p>
      </section>
    </div>
  );
};

export default PolitiqueDeConfidentialitePage;
